module.exports = __webpack_public_path__ + "static/media/bingo safari unscratched.533eb905.png";